import React from 'react';
import { t } from 'i18next';

import { ReactComponent as AdmiralIcon } from '../../image/admiral.svg';
import { ShipyardContext } from '../Context';

import './UserType.scss';

/**Component for rendering user type as stylized text.
 * @param {Object} props Incoming JSX attributes.
 * @param {number} props.userType User Type ID.
 */
function UserType({ userType }) {
    const { userSettings } = React.useContext(ShipyardContext);

    // #TODO TechDebt - Leverage the database for these
    const TSBEnums = {
        1: 'Applicant',
        3: 'Admin',
        4: 'Admiral',
    };

    return (
        <div className={'user-type-component user-type-' + userType}>
            <div className="icon">
                <AdmiralIcon />
            </div>
            <span>{userSettings?.ClientOrgId === 7 ? TSBEnums[userType] : t('UserType.' + userType)}</span>
        </div>
    );
}

export default UserType;
